import { helpTree } from '$lib/help'

export const prerender = true

export const load = () => {
  return { tree: helpTree }
}
